import dayjs from "dayjs";
import { Button } from "@/components/ui/button";
import ElipsisIcon from "../icons/elipsis";
import ShareIcon from "../icons/share";
import "dayjs/locale/tr";

dayjs.locale("tr");

const ShareButton = () => {
  return (
    <Button size="icon-sm" variant="ghost">
      <ShareIcon className="stroke-brand-blue-500 size-6 stroke-[1.5]" />
    </Button>
  );
};

const MoreActionButton = () => {
  return (
    <Button size="icon-sm" variant="ghost">
      <ElipsisIcon className="stroke-brand-blue-500 size-6 stroke-[1.5]" />
    </Button>
  );
};

const ContentDate = ({ publishedAt }: { publishedAt: string }) => {
  return (
    <span className="text-sm leading-5 font-semibold text-neutral-400">
      {dayjs(publishedAt).format("DD MMMM YYYY")}
    </span>
  );
};

export { ShareButton, MoreActionButton, ContentDate };
